<template>
    <div class="row">
        <div class="col-md-12 preloader">
            <div class="preloader__status">
                <div status class="preloader__status-text">Загружено на {{loaded}}%</div>
                <div class="preloader__status-loader">
                    <div loader :style="loadStyle" class="preloader__status-bar"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import $ from 'jquery'

    export default {
        name: 'preloader',
        data () {
            return {
                loaded: 0,
                loading: null,
                loadStyle: {
                    width: '0%'
                },
                statusElem: $('[status]'),
                loader: $('[loader]'),
                body: $('body')
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                // код, уже предполагающий наличие this.$el в документе
                $('.init').remove();
                this.preloader = $('.preloader');
                this.removeScrolling();
                this.startLoading();
            })
        },

        watch: {
            loaded: function loaded() {
                this.loadStyle.width = this.loaded + '%';
            }
        },
        methods: {
            removeScrolling: function removeScrolling() {
                this.body.css('overflow', 'hidden');
            },
            startLoading: function startLoading() {
                this.loading = setInterval(this.load, 20);
            },
            load: function load() {
                this.loaded < 100 ? this.loaded++ : this.doneLoading();
            },
            doneLoading: function doneLoading() {
                clearInterval(this.loading);
                this.updateStatus();
            },
            updateStatus: function updateStatus() {
                this.statusElem.text('Готов к работе!');
                this.loader.fadeOut();
                this.animatePreloader();
            },
            animatePreloader: function animatePreloader() {
                var app = this,
                    height = this.preloader.height(),
                    properties = {
                        'margin-top': '-' + height
                    },
                    options = {
                        duration: 1000,
                        easing: 'swing',
                        complete: function complete() {
                            app.removePreloader();
                        }
                    };
                this.preloader.delay(500).animate(properties, options);
            },
            removePreloader: function removePreloader() {
                this.preloader.remove();
                this.body.removeAttr('style');
                this.animateWebsite();
            },
            animateWebsite: function animateWebsite() {
                //console.log('lets get pretty');
            }
        }
    }
</script>

<style lang="less">
    .preloader {
        width: 100%;
        height: 100vh;
        background: #FDE5E5;
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #781115;
        font-family: 'Raleway', sans-serif;
        position: relative;
    }
    .preloader__status {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .preloader__status-text {
        font-size: 40px;
        font-family: 'Raleway', sans-serif;
        margin-bottom: 20px;
    }
    .preloader__status-loader {
        width: 100%;
        height: 3px;
    }
    .preloader__status-bar {
        background: #781115;
        height: 100%;
    }
    .frontpage {
        height: 100vh;
        background: #34495e;
    }
    .frontpage__title {
        color: white;
    }
</style>



// WEBPACK FOOTER //
// preload.vue?4d799b7c